/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import icons from './icons';
import replace from './replace';

import './animation.scss';

export { icons, replace };
